import { useEffect, useState } from "react";
import { DialogDescription, DialogTitle } from "@/components/ui/dialog";
import CediWinkFace from "@/components/rideshare/CediWinkFace";

// Amount eases up to its value (Apple Pay style), shown in fixed 2-dp so the width stays steady.
const CountUp = ({ value, ms = 700 }) => {
  const [n, setN] = useState(0);
  useEffect(() => {
    let raf = 0;
    const t0 = performance.now() + 500;
    const tick = (t) => {
      const k = Math.min(1, Math.max(0, (t - t0) / ms));
      setN(value * (1 - Math.pow(1 - k, 3)));
      if (k < 1) raf = requestAnimationFrame(tick);
    };
    raf = requestAnimationFrame(tick);
    return () => cancelAnimationFrame(raf);
  }, [value, ms]);
  return n.toFixed(2);
};

const LINES = {
  momo: "The customer paid with MoMo in the app. Their receipt is on its way and your earnings are updated.",
  cash: "Cash payment confirmed. The customer's receipt is on its way and your earnings are updated.",
};

// Winking ₵ face + "Payment received" + counted-up amount. Sound/vibration are fired by the caller.
export default function PaymentCelebration({ amount, method = "cash", who }) {
  return (
    <div className="px-8 pt-20 pb-10 min-h-[60dvh] flex flex-col items-center justify-center text-center" data-testid="pay-confirm-celebration">
      <CediWinkFace />
      <DialogTitle className="cedi-rise text-[22px] font-semibold tracking-tight mt-12" style={{ animationDelay: "450ms" }} data-testid="pay-confirm-celebration-title">{method === "withdrawal" ? "Money in your MoMo" : "Payment received"}</DialogTitle>
      <p className="cedi-rise text-[34px] font-bold tracking-tight text-[#0F8A5F] mt-0.5 tabular-nums" style={{ animationDelay: "540ms" }} data-testid="pay-confirm-celebration-amount">GHS <CountUp value={amount} /></p>
      <DialogDescription className="cedi-rise mt-2 max-w-[280px] text-[15px] leading-snug text-[#6E6E73]" style={{ animationDelay: "640ms" }}>
        {method === "withdrawal" ? `Your withdrawal has landed in your ${who || "MoMo"}. A receipt is on its way by SMS.` : who ? (method === "momo" ? `${who} paid with MoMo in the app. Their receipt is on its way and your earnings are updated.` : `${who} paid in cash. Their receipt is on its way and your earnings are updated.`) : (LINES[method] || LINES.cash)}
      </DialogDescription>
    </div>
  );
}
